








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({
    type: String,
    default: 'default',
    validator: (type: string) => ['default', 'outline', 'outline-gray', 'text', 'danger'].includes(type)
  })
  type!: string;
}
